<template>
    <div>
        <selected-filters
            :selected="filterValues"
            :translatable="['transferType', 'cancellationPolicy']"
            @delete-filter="clearFilter"
        />
        <price-filter
            :filter-values="filterValues"
            :filters="filters"
            :label="$t('price')"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            label="Transfer name"
            :filters="filters"
            filter="name"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.cancellationPolicy && filters.cancellationPolicy.length > 0"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="cancellationPolicy"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.transferType && filters.transferType.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="transferType"
            :translate-labels="true"
            :pluralization="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.productVariantId && filters.productVariantId.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="productVariantId"
            :translate-labels="true"
            :pluralization="false"
            @change="change($event)"
        >
            <template v-slot:label="{value}">
                <ProductVariantLabel :product="{productVariantId: +value}" class="me-1" show-label />
            </template>
        </checkbox-filter>
        <filtered-mobile-button
            v-if="$breakpoint.smAndDown"
            class="sticky-button"
            :count="filteredOffersCount"
            :visible="Object.keys(filterValues).length > 0"
            @change-mode="goToOffers"
            @clear-filters="reset"
        />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import CheckboxFilter from '@/components/search/filters/CheckboxFilter.vue'
    import TripadvisorFilter from '@/components/search/filters/TripadvisorFilter.vue'
    import FilteredMobileButton from '~/components/snippets/FilteredMobileButton.vue'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import SelectedFilters from '~/components/snippets/SeletedFilters.vue'
    import {FiltersBase} from '@/components/search/FiltersBase.vue'
    import ProductVariantLabel from '~/components/snippets/ProductVariantLabel.vue'

    @Component({
        components: {
            ProductVariantLabel,
            PriceFilter,
            CheckboxFilter,
            TripadvisorFilter,
            FilteredMobileButton,
            NameFilter,
            SelectedFilters,
        },
    })
    export class TransferFilters extends FiltersBase {}

    export default TransferFilters
</script>
